module.exports = __webpack_public_path__ + "static/media/documents_002.23023522.svg";